<template>
  <div>
    <nav-bar></nav-bar>
    <router-view class="mb-20"></router-view>
    <footer-nav></footer-nav>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar'
import FooterNav from '@/components/FooterNav'

export default {
  name: 'home',
  components: {
    NavBar,
    FooterNav
  }
}
</script>

<style lang="scss" scoped>
</style>
